import React from "react";
const UserNavItem = ({ variant, imgUrl, altText, children, href }) => {
  return (
    <a
      href={href}
      className={variant ? `user_nav_item ${variant}` : "user_nav_item"}
    >
      <div className="user_nav_img">
        <img src={imgUrl} alt={altText} />
      </div>
      <span className="user_nav_text">{children}</span>
    </a>
  );
};
UserNavItem.defaultProps = {
  href: "#",
};
export default UserNavItem;
